import React, { useState } from "react";
import { useQuery } from "react-query";
import { QK } from "../../../base/qk";
import {
  Box,
  Card,
  CardContent,
  Tabs,
  Tab,
  Typography,
  alpha,
  useTheme,
  Fade,
} from "@mui/material";
import {
  AssignmentOutlined as PlanIcon,
  FactCheckOutlined as AssessmentIcon,
} from "@mui/icons-material";
import CarePlans from "./CarePlans";
import { getCarePlans } from "../../../api/services/carePathWay";
import Assessments from "./Assessments/Assessments";

const CarePathway = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const { data: forms, refetch } = useQuery([QK.carePlans], () => getCarePlans());

  const handleFormCreate = () => setShowCreateModal(true);
  const handleChange = (event, newValue) => setActiveTab(newValue);

  return (
    <Box sx={{ width: "100%" }}>
      <Card
        sx={{
          width: "100%",
          borderRadius: "14px",
          border: "1px solid #EAECF0",
          boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.04)",
          overflow: "hidden",
          mb: 2,
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            bgcolor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: "10px",
              bgcolor: alpha(theme.palette.primary.main, 0.08),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <PlanIcon
              sx={{ color: theme.palette.primary.main, fontSize: 18 }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "0.9rem",
                fontWeight: 600,
                color: "#101828",
                letterSpacing: "-0.01em",
                lineHeight: 1.2,
              }}
            >
              Care Pathway
            </Typography>
            <Typography
              sx={{
                fontSize: "0.7rem",
                color: "#667085",
                mt: 0.2,
                lineHeight: 1.2,
              }}
            >
              Manage care plans and assessments
            </Typography>
          </Box>
        </Box>
      </Card>

      <Card
        sx={{
          width: "100%",
          borderRadius: "14px",
          border: "1px solid #EAECF0",
          boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.04)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 2,
            pt: 1,
            bgcolor: "#FFFFFF",
            borderBottom: "1px solid #EAECF0",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 40,
              "& .MuiTabs-indicator": {
                backgroundColor: "#2469F0",
                height: 2.5,
                borderRadius: "3px 3px 0 0",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.8rem",
                minHeight: 40,
                color: "#667085",
                px: 2,
                "&.Mui-selected": {
                  color: "#2469F0",
                },
              },
            }}
          >
            <Tab
              icon={<PlanIcon sx={{ fontSize: 18 }} />}
              iconPosition="start"
              label="Care Plans"
              sx={{ gap: 0.5 }}
            />
            <Tab
              icon={<AssessmentIcon sx={{ fontSize: 18 }} />}
              iconPosition="start"
              label="Assessments"
              sx={{ gap: 0.5 }}
            />
          </Tabs>
        </Box>

        <CardContent sx={{ p: 3, bgcolor: "#F8FAFC" }}>
          <Fade in={true} timeout={600}>
            <Box>
              {activeTab === 0 && (
                <CarePlans forms={forms} handleCreate={handleFormCreate} />
              )}

              {activeTab === 1 && <Assessments />}
            </Box>
          </Fade>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CarePathway;